import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 600,
  },
});


export default function CustomMappingTable(props) {
  const classes = useStyles();
  const rows = props?.data
  return (
    <TableContainer component={Paper}>
    <p className={'my-2 mx-3'}>Course To Program Outcome Mapping</p>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align='left'>SI No.</TableCell>
            <TableCell>Course (Course Code)</TableCell>
            <TableCell align="right">PO1</TableCell>
            <TableCell align="right">PO2</TableCell>
            <TableCell align="right">PO3</TableCell>
            <TableCell align="right">PO4</TableCell>
            <TableCell align="right">PO5</TableCell>
            <TableCell align="right">PO6</TableCell>
            <TableCell align="right">PO7</TableCell>
            <TableCell align="right">PO8</TableCell>
            <TableCell align="right">PO9</TableCell>
            <TableCell align="right">PO10</TableCell>
            <TableCell align="right">PO11</TableCell>
            <TableCell align="right">PO12</TableCell>
            <TableCell align="right">PSO1</TableCell>
            <TableCell align="right">PSO2</TableCell>
            <TableCell align="right">PSO3</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row,index) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {index+1}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.title}
              </TableCell>
              <TableCell align="right">1</TableCell>
              <TableCell align="right">2</TableCell>
            </TableRow>
          ))}
          
        </TableBody>
      </Table>
    </TableContainer>
  );
}
